import React from 'react';
import {
  Button, ButtonText, Text, VStack,
} from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

export type DashboardEmptyStateProps = {
  onResetFilters: () => void;
};

/**
 * Shown when no finished sessions match the current filters.
 */
export function DashboardEmptyState({ onResetFilters }: DashboardEmptyStateProps) {
  const { t } = useTranslation();

  return (
    <VStack space="md" py="$6" testID="dashboard-empty-state">
      <Text size="md" color="$textBody">{t('admin.analytics.empty.message')}</Text>
      <Button
        size="sm"
        variant="outline"
        action="secondary"
        alignSelf="flex-start"
        onPress={onResetFilters}
        testID="dashboard-reset-filters"
      >
        <ButtonText>{t('admin.analytics.resetFilters')}</ButtonText>
      </Button>
    </VStack>
  );
}
